(function($, root, undefined) {
  $(function() {
    'use strict';

    var $window = $(window);

    console.log('enabled');

    //if div is visible in the viewport function
    $.fn.isInViewport = function() {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();

      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();

      return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    //if div is center in of the viewport function
    $.fn.center = function(parent) {
      if (parent) {
        parent = this.parent();
      } else {
        parent = window;
      }
      this.css({
        "position": "absolute",
        "top": ((($(parent).height() - this.outerHeight()) / 2) + $(parent).scrollTop() + "px"),
        "left": ((($(parent).width() - this.outerWidth()) / 2) + $(parent).scrollLeft() + "px")
      });
      return this;
    }

    // smooth scrolling
    $(document).on('click', '.skip', function(event) {
      event.preventDefault();

      $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 100
      }, 800);
    });


    //menu
    var isActive = false;
    $('.menu-open-btn').on('click', function() {
      if (isActive) {
        $('html, .mobile-overlay').removeClass('menu-open');
      } else {
        $('html, .mobile-overlay').addClass('menu-open');
      }
      isActive = !isActive;
    });
    $('.menu-close-btn').on('click', function() {
      if (isActive) {
        $('html, .mobile-overlay').removeClass('menu-open');
      } else {
        $('html, .mobile-overlay').addClass('menu-open');
      }
      isActive = !isActive;
    })

    //validate forms 
    if ($('form').length) {
      $("form").each(function() {
        $(this).validate();
      })
    }

    //header + dropdown 
    function stickyHeader() {
      var $windowheight = $(window).scrollTop();
      var $headerheight = $('#header').outerHeight(true);
      //pink top adjustment on secondary pages
      if ($('body.secondary').length) {
        var newIntroPadding = $headerheight + 100;
        if ($window.width() < 860) {
          $('.section.intro').css('padding-top', $headerheight + 25);
        } else {
          $('.section.intro').css('padding-top', newIntroPadding);
        }
      }
      $('#header_placeholder').css('height', $headerheight - 1);
      if ($windowheight > ($headerheight + 300)) {
        $('#header').addClass('sticky white-bg');
        $('.dropdown').addClass('sticky');
        if ($('#about').length || $('#portfolio').length || $('body.secondary').length) {
          $('.dropdown').mouseleave(function() {
            $('#header').addClass('white-bg');
          })
        }
        $('.dropdown').mouseleave(function() {
          $('.dropdown').removeClass('visible active');
        })
      } else {
        $('#header').removeClass('sticky');
        if ($('.full-hero').length) {
          if ($('#about').length || $('#portfolio').length) {
            $('#header').removeClass('white-bg');
            $('.dropdown').mouseleave(function() {
              $('#header').removeClass('white-bg');
            })
          } else {
            $('#header').addClass('white-bg');
          }
          $('.dropdown').removeClass('sticky');
        }
        if ($('body.secondary').length) {
          $('#header').removeClass('white-bg');
          $('.dropdown').mouseleave(function() {
            $('#header').removeClass('white-bg');
          })
        }
      }
    }
    var $headerheight = $('#header').outerHeight(true);
    $('#header_placeholder').css('height', $headerheight - 1);
    //pink top adjustment on secondary pages
    if ($('body.secondary').length) {
      var newIntroPadding = $headerheight + 100;
      if ($window.width() < 860) {
        $('.section.intro').css('padding-top', $headerheight + 25);
      } else {
        $('.section.intro').css('padding-top', newIntroPadding);
      }
    }
    $('.dropdown').css('transform', "translateY(" + $headerheight + "px)")
    $('#header').mouseover(function() {
      if ($('body.secondary').length) {
      } else {
        $(this).addClass('white-bg');
      }
    }).mouseleave(function() {
      if ($('.dropdown').hasClass('visible')) {} else {
        if ($('#header').hasClass('sticky')) {} else {
          // $(this).removeClass('white-bg');   
        }
      }
      if ($('#about').length || $('#portfolio').length || $('body.secondary').length) {
        if ($('.dropdown').hasClass('visible') || $('#header').hasClass('sticky')) {} else {
          $('#header').removeClass('white-bg');
        }
      }

    })
    if ($('.dropdown-parent').length) {
      if ($('.full-hero').length) {
        $('.dropdown-parent').mouseover(function() {
          $('.dropdown').addClass('visible');
          $('#header').addClass('white-bg');
          $(this).addClass('active');
        });
        $('.dropdown').mouseleave(function() {
          $('.dropdown').removeClass('visible');
          if ($('#about').length || $('#portfolio').length) {
            $('#header').removeClass('white-bg');
          }

          $('.dropdown-parent').removeClass('active')
        });
      } else {
        $('.dropdown-parent, .dropdown').mouseover(function() {
          $('.dropdown').addClass('visible');
          $(this).addClass('active');
        });
        $('.dropdown').mouseleave(function() {
          if ($('#header').hasClass('sticky')) {} else {
            $('.dropdown').removeClass('visible');
            $('.dropdown-parent').removeClass('active')
          }
          if ($('body.secondary').length) {
            $('#header').removeClass('white-bg');
            $('.dropdown').removeClass('visible active');
          }
        });
      }

      $('#header ul li:not(.dropdown-parent)').mouseenter(function() {
        $('.dropdown').removeClass('visible');
        $('.dropdown-parent').removeClass('active');
      })      

      $('#header .dropdown-parent').hover(function() {
        var $dropdown = $('.dropdown .wrapper')
        var $items = $(this).find('.dropdown-child').html()
        //empties the dropdown and replaces it with dropdown stuff
        $dropdown.empty();
        $dropdown.html($items);
      })

    }
    $('#header .search').on('click', function() {
      $('.search-container').slideDown(function() {
        var $headerheight = $('#header').outerHeight(true);
        $('.dropdown').css('transform', "translateY(" + $headerheight + "px)")
        // $('.dropdown').css('top', $headerheight)
        $('#header').addClass('white-bg');
      });
    })
    $('#header .search-container .close').on('click', function() {
      $('.search-container').slideUp(function() {
        var $headerheight = $('#header').outerHeight(true);
        $('.dropdown').css('transform', "translateY(" + $headerheight + "px)")
        if($('#header.white-bg').length){
          $('#header').addClass('white-bg');
        } else {
          $('#header').removeClass('white-bg');
        }
        // $('.dropdown').css('top', $headerheight)
      });
    })

    // scroll top
    function scrollHome() {
      var $windowheight = $(window).scrollTop();
      var $headerheight = $('#header').outerHeight(true);
      if ($windowheight > ($headerheight + 300)) {
        $('.scrolltop').fadeIn(300);
      } else {
        $('.scrolltop').fadeOut(300);
      }
    }
    $(".scroll").click(function() {
      $("html,body").animate({
        scrollTop: $("body").offset().top
      }, "1000");
      return false
    })

    // popup 
    var isshow = sessionStorage.getItem('isshow');
    if ($('.newsletter-popup').length) {
      setTimeout(function() {
        if (isshow == null) {
          sessionStorage.setItem('isshow', 1);
          $('.newsletter-popup').addClass('show');
        }
      }, 4000);
    }
    $('.newsletter-popup .close').click(function() {
      $('.newsletter-popup').removeClass('show');
    });

    //cart slide out
    if ($('.cart').length) {
      $('.cart').on('click', function(e) {
        e.preventDefault();
        $('.cart-items').addClass('open');
        $('.cart-overlay').addClass('show');
        $('body').addClass('cart-open');
      })
      //close cart by clicking "close" within cart
      $('.close-cart').on('click', function() {
        $cartItems.removeClass('open');
        $cartOverlay.removeClass('show');
        $('body').removeClass('cart-open');
      })
      //close cart by clicking outside
      var $cart = $('.cart');
      var $cartItems = $('.cart-items');
      var $cartOverlay = $('.cart-overlay');
      $($cartOverlay).on('click touchstart', function(e) {
        if (!$cart.is(e.target) && $cart.has(e.target).length === 0) {
          $cartItems.removeClass('open');
          $cartOverlay.removeClass('show');
          $('body').removeClass('cart-open');
        }
      });
    }

    //home press slider 
//     if ($('#home').length) {
//       if ($window.width() < 1100) {
//         $('#home .press .items').slick({
//           dots: false,
//           prevArrow: $('.press svg.left'),
//           nextArrow: $('.press svg.right'),
//           slidesToShow: 2,
//           slidesToScroll: 1,
//           infinite: true,
//           responsive: [{
//             breakpoint: 600,
//             settings: {
//               slidesToShow: 1,
//               slidesToScroll: 1
//             }
//           }]
//         });

//       }
//       if ($window.width() < 860) {
//         $('#home .featured-collections .flex').not('.slick-initialized').slick({
//           dots: true,
//           arrows: false,
//           slidesToShow: 3,
//           slidesToScroll: 1,
//           infinite: true,
//           responsive: [{
//               breakpoint: 767,
//               settings: {
//                 slidesToShow: 2
//               }
//             },
//             {
//               breakpoint: 600,
//               settings: {
//                 slidesToShow: 1
//               }
//             }
//           ]
//         });

//       }
//     }

    //thumbs
    if ($('.thumbs').length) {
      $('.thumbs').slick({
        dots: true,
        vertical: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        verticalSwiping: true,
        prevArrow: $('.arrow.up'),
        nextArrow: $('.arrow.down')
      })
      $('.thumb').on('click', function() {
        var $thumbimage = $(this).children().attr('src');
        $('.main .featured').attr('src', $thumbimage);
        $('.thumb').removeClass('active');
        $(this).addClass('active');
      })
    }

    if ($('#product').length) {
      $('#product .main .mobile-gallery').slick({
        dots: true,
        prevArrow: $('.arrow.left'),
        nextArrow: $('.arrow.right')
      });
    }

    //project 
    if ($('#project').length) {
      $('.gallery').slick({
        slidesToSfhow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        centerMode: true,
        // centerPadding: '250px',
        variableWidth: true,
        prevArrow: $('.arrow.left'),
        nextArrow: $('.arrow.right'),
        responsive: [{
          breakpoint: 860,
          settings: {
            centerPadding: '150px'
          }
        }]
      });
      //project next prev image arrow resize
      var $slickSlideHeight = $('#project .slick-slide img').outerHeight(true);
      $('#project .arrow.img').css('height', $slickSlideHeight);
    }

    //insta slider
//     if ($('.insta').length) {
//       $('.insta .cols').slick({
//         slidesToShow: 4,
//         slidesToScroll: 1,
//         prevArrow: $('.left-arrow'),
//         nextArrow: $('.right-arrow'),
//         responsive: [{
//           breakpoint: 860,
//           settings: {
//             slidesToShow: 2
//           }
//         }]
//       })
//     }

    //accordion
    if ($('.accordion').length) {
      $(".item > .title").on("click", function() {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $(this).siblings(".content").slideUp(200);
          $(".item > .title i").removeClass("minus").addClass("plus");
        } else {
          $(".item > .title i").removeClass("minus").addClass("plus");
          $(this).find("i").removeClass("plus").addClass("minus");
          $(".item > .title").removeClass("active");
          $(this).addClass("active");
          $(".accordion .content").slideUp(200);
          $(this).siblings(".content").slideDown(200);
        }
      });
    }

    //blog post side by side images
    if ($('#post').length) {
      var $floatLeftEl = $('img[style*="float"]');
      $floatLeftEl.addClass('float');
    }


    //detect IE 
    function GetIEVersion() {
      var sAgent = window.navigator.userAgent;
      var Idx = sAgent.indexOf("MSIE");

      // If IE, return version number.
      if (Idx > 0)
        return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));

      // If IE 11 then look for Updated user agent string.
      else if (!!navigator.userAgent.match(/Trident\/7\./))
        return 11;

      else
        return 0; //It is not IE
    }

    if (GetIEVersion() > 0) {
      console.log("This is IE " + GetIEVersion());

      $('.flex .col:not(.cart-items .flex .col), .select').addClass('ie');

    }

    //mobile disable hover
    function hasTouch() {
      return 'ontouchstart' in document.documentElement ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0;
    }

    if (hasTouch()) { // remove all :hover stylesheets
      try { // prevent exception on browsers not supporting DOM styleSheets properly
        for (var si in document.styleSheets) {
          var styleSheet = document.styleSheets[si];
          if (!styleSheet.rules) continue;

          for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
            if (!styleSheet.rules[ri].selectorText) continue;

            if (styleSheet.rules[ri].selectorText.match(':hover')) {
              styleSheet.deleteRule(ri);
            }
          }
        }
      } catch (ex) {}
    }



    // scroll functions
    $(window).on('scroll', function() {
      var $window = $(window);

      stickyHeader();

      scrollHome();

      if ($window.width() < 1100) {
        if ($('#post').length) {
          if ($('#footer').isInViewport()) {
            $('.share-this').removeClass('show');
          } else {
            $('.share-this').addClass('show');
          }
        }
      }

    });

    function resizeWindow() {

      var $window = $(window);

      stickyHeader();

      $('html').removeClass('frozen');


      //home press slider 
      if ($('#home').length) {
        if ($window.width() < 1100) {
          $('#home .press .items').not('.slick-initialized').slick({
            dots: false,
            prevArrow: $('.press svg.left'),
            nextArrow: $('.press svg.right'),
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            responsive: [{
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }]
          });

        } else {
          if ($('#home .press .items').hasClass('slick-initialized')){
          $('#home .press .items').slick('unslick');
          }
        }
        if ($window.width() < 860) {
          $('#home .featured-collections .flex').not('.slick-initialized').slick({
            dots: true,
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            responsive: [{
                breakpoint: 767,
                settings: {
                  slidesToShow: 2
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1
                }
              }
            ]
          });
        } else {
          if ($('#home .featured-collections .flex').hasClass('slick-initialized')){
            $('#home .featured-collections .flex').slick('unslick');
          }        
        }
      }

      //project next prev image arrow resize
      if ($('#project').length) {
        var $slickSlideHeight = $('#project .slick-slide img').outerHeight(true);
        $('#project .arrow.img').css('height', $slickSlideHeight);
      }



    }

    resizeWindow();

    $window.resize(resizeWindow);



  });
})(jQuery, this);